import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {ShoppingCart} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

type OrdersMenuConfig = {
  hasOrderManagement: boolean;
  hasLegacyOrderManagement: boolean;
  hasOrdersCsvImport: boolean;
};

export const getOrdersMenu = ({
  hasOrderManagement = false,
  hasLegacyOrderManagement = false,
  hasOrdersCsvImport = false,
}: OrdersMenuConfig): MenuItemConfig => {
  const hasOrderAccess = hasOrderManagement || hasLegacyOrderManagement;

  const menuItems = {
    type: 'parent',
    label: 'shipment.menu.items.order',
    multiplyLabel: true,
    icon: markRaw(ShoppingCart),
    show: () => hasOrderAccess,
    children: [
      {
        type: 'internal',
        label: 'overview',
        to: {
          name: 'orders-overview',
        },
        activeRouteNameAliases: ['orders-overview', 'orders-import-overview'],
        show: () => hasOrderAccess,
      },
      {
        type: 'internal',
        to: {
          name: 'addresses',
        },
        label: 'location.addressBook.addressBook',
        show: () => hasOrderManagement,
      },
      {
        type: 'internal',
        label: 'orders.import.manual',
        to: {
          name: 'orders-import-overview',
        },
        activeRouteNameAliases: ['orders-import-edit', 'orders-import-overview'],
        show: () => hasLegacyOrderManagement,
      },
      {
        type: 'internal',
        label: 'orders.import.manual',
        to: {
          name: 'orders-csv-import',
        },
        activeRouteNameAliases: ['orders-csv-import'],
        show: () => hasOrdersCsvImport && hasOrderManagement,
      },
    ],
  };

  return menuItems;
};
